import React from 'react';
import { Box, Text } from '@nerdwallet/currency';
import PropTypes from 'prop-types';
import Image from '@nerdwallet/react-image';
import classNames from 'classnames';

import styles from './diversity-carousel.module.less';

const DiversityCarouselTile = ({
  icon,
  altImage,
  title,
  content,
  wideImage,
}) => (
  <Box
    className={styles.carouselCardContainer}
    shadow="1"
    padding="4"
    margin="2"
  >
    <Box
      marginBottom="3"
      marginX="auto"
      className={classNames(styles.carouselCardImage, {
        [styles.wideImage]: wideImage,
      })}
    >
      <Image src={icon} alt={altImage} backgroundColor="transparent" lazy />
    </Box>
    <Box paddingBottom="2">
      <Text bold>{title}</Text>
    </Box>
    <Box marginBottom="2">{content}</Box>
  </Box>
);

DiversityCarouselTile.displayName = 'Diversity Carousel';
DiversityCarouselTile.analyticsName = 'diversity_carousel';

DiversityCarouselTile.propTypes = {
  icon: PropTypes.string,
  altImage: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  wideImage: PropTypes.bool,
};

export default DiversityCarouselTile;
